import { z } from 'zod';
import { CREATOR_ALL_SEARCH_CARD_COUNT } from '@services/MarppleShop/features/Creator/constant';

export const CreatorSearchQuerySchema = z.object({
  // locals
  login_user_adult_id: z.number().optional().catch(undefined),
  // query
  search: z.coerce.string().optional().catch(undefined),
  st_id: z.coerce.number().optional().catch(undefined),
  page: z.coerce.number().optional().catch(undefined),
  user_id: z.coerce.number().optional().catch(undefined),
  order: z.enum(['monthly_ranking', 'popularity_score']).optional().catch('monthly_ranking'),
});

export const CreatorSearchQueryResultSchema = CreatorSearchQuerySchema.extend({
  name: z.string(),
  limit: z.number(),
  offset: z.number(),
  page: z.number(),
});

export const createCreatorSearchQueryValidator = (limit = CREATOR_ALL_SEARCH_CARD_COUNT) => {
  return CreatorSearchQuerySchema.transform((data) => {
    return {
      ...data,
      name: data.search || '',
      limit,
      offset: limit * Math.max((data.page || 0) - 1, 0),
      page: data.page || 1,
      order: data.order ?? 'monthly_ranking',
    };
  });
};
